import { render, staticRenderFns } from "./ChordDiagram.vue?vue&type=template&id=38e831d4&scoped=true&"
import script from "./ChordDiagram.vue?vue&type=script&lang=js&"
export * from "./ChordDiagram.vue?vue&type=script&lang=js&"
import style0 from "./ChordDiagram.vue?vue&type=style&index=0&id=38e831d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e831d4",
  null
  
)

export default component.exports